import { http, HttpHandler, HttpResponse } from 'msw';
import { thankYouDetailsMock } from '../../../api';

export const mocks = {
  details: http.get('*/v1/public/unmoderated-test/:share_id/thank-you/', () =>
    HttpResponse.json(thankYouDetailsMock, { status: 200 }),
  ),
} satisfies Record<PropertyKey, HttpHandler>;
